import React, { useEffect, useState } from "react";
import { Button, Divider } from "antd";
import { NavLink, Link, useHistory } from "react-router-dom";
import "./landing-page-header.style.less";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import RequestFinancingPopup from "./Finance/RequestFinancingPopup";

const scrollToElement = (element) => {
  var elementPosition;
  if (element === "standardize-processes") {
    elementPosition = document.getElementById(element).offsetTop - 160;
  } else if (element === "top") {
    window.scrollTo(0, 0);
  } else {
    elementPosition = document.getElementById(element).offsetTop - 550;
  }
  window.scrollTo(0, elementPosition);
};

const LandingPageHeader = (props) => {
  const { flag, location } = props;

  const [requestFinance, setRequestFinance] = useState(false);

  const isDataDashboard = location?.pathname?.includes("/data-dashboard");

  useEffect(() => {
    if (isDataDashboard) {
      disableMainHeader();
    }
  }, [props]);

  const disableMainHeader = () => {
    const landingPageHeader = document.querySelector(
      ".site-page-header-ghost-wrapper"
    );
    if (landingPageHeader) {
      landingPageHeader.style.display = "none";
    }
  };

  return (
    <>
      <div className="landing-header-wrapper">
        <div className="main-header-link-wrapper">
          <nav className="main-header-nav-wrapper">
            <ul className="main-header-list-wrapper">
              <li className="main-header-logo">
                <div
                  className="main-header-logos-wrapper"
                  onClick={() => scrollToElement("top")}
                >
                  <NavLink activeClassName="is-active" to="/">
                    <img
                      src={require("../../assets/logos/SafEarth Logo_Blue with White.png")}
                    />
                  </NavLink>
                  <Divider type="vertical" />
                  {/* <NavLink activeClassName="is-active" to="/"> */}
                  <img
                    src={require("../../assets/images/Landing-Page/Solar-Flow-Nav-Logo.png")}
                    className="solar-flow-nav-logo"
                  />
                  {/* </NavLink> */}
                </div>
              </li>

              <div className="center-links">
                <li className="features-li">
                  {flag !== true && (
                    <Link
                      activeClassName="is-active"
                      onClick={() =>
                        scrollToElement("solarflow-platform-features")
                      }
                      className="features-link"
                    >
                      Features
                    </Link>
                  )}
                </li>
                <li>
                  {flag !== true && (
                    <a onClick={() => setRequestFinance(true)}>Financing</a>
                  )}
                </li>
                <li className="whats-more-li">
                  {flag !== true && (
                    <Link
                      activeClassName="is-active"
                      onClick={() => scrollToElement("standardize-processes")}
                      className="whats-more-link"
                    >
                      What's More
                    </Link>
                  )}
                </li>
              </div>

              <div className="right-links">
                <li className="login-li">
                  <NavLink activeClassName="is-active" to="/login">
                    <Button className="login-btn">Login</Button>
                  </NavLink>
                </li>
                <li className="signup-li">
                  <a href="https://safearth.in/signUp/vendor">
                    <Button type="primary" className="signup-btn">
                      Signup
                    </Button>
                  </a>
                </li>
              </div>
            </ul>
          </nav>
        </div>
        <RequestFinancingPopup
          visible={requestFinance}
          setVisible={setRequestFinance}
        />
      </div>
    </>
  );
};

export default withRouter(LandingPageHeader);
